import type { TrackingFn } from '@change-corgi/core-react/tracking';

function getTrackingCommonData() {
	return {
		location: 'qr_code_download',
	};
}

export function trackShareSuccess(
	eventName: string,
	trackingData: Record<string, string | number | boolean | undefined> | undefined,
	track: TrackingFn,
): void {
	void track(eventName, { ...getTrackingCommonData(), ...trackingData });
}
